export default "__VITE_ASSET__C7Z0VuXb__"